import type { Nullable } from '@clearverify/types';

import type { PeoPayrollProviderInfoFragment } from 'src/api';

export enum InviteFormFields {
  peoPayrollProvider = 'peoPayrollProvider',
  peos = 'peos',
}

export enum InviteFormPeoFields {
  email = 'email',
  isRevenueShareEnabled = 'isRevenueShareEnabled',
}

export type Peo = {
  [InviteFormPeoFields.email]: string;
  [InviteFormPeoFields.isRevenueShareEnabled]: boolean;
};

export type InviteFormValues = {
  [InviteFormFields.peoPayrollProvider]: Nullable<PeoPayrollProviderInfoFragment>;
  [InviteFormFields.peos]: Peo[];
};
